module.exports = __webpack_public_path__ + "static/media/pokeball.94e72fec.png";